module.exports = __webpack_public_path__ + "static/img/card_1_1.99264a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/es/card_1_1.png
// module id = khzb
// module chunks = 0